import { NgModule } from '@angular/core';
import { AllKeysSameValuePipe } from './all-keys-same-value.pipe';

@NgModule({
    declarations: [AllKeysSameValuePipe],
    exports: [AllKeysSameValuePipe],
})
export class AllKeysSameValuePipeModule { }